module.exports = __webpack_public_path__ + "img/300x600_layout_2.77eeb94b.svg";